import { apiClient } from '@/utils/api-client';
import type { FeeAccrualsResponse, Granularity } from '@/types/fee-accruals';

export const feeAccrualService = {
  async getAccruals(
    fundId: string,
    granularity: Granularity = 'monthly'
  ): Promise<FeeAccrualsResponse> {
    return await apiClient.get(
      `/funds/${fundId}/fee-accruals?granularity=${granularity}`
    );
  },
};
